import { initialState } from "PFCore/initial_state/index";
import { mainDispatch } from "PFCore/reducers/main_dispatch";
import { mainReducer } from "PFCore/reducers/main_reducer";
import { PropsWithChildren, useCallback, useReducer } from "react";

import { AppDispatchContext, AppStoreContext } from "./app_context";

export const AppContextProvider = ({ children }: PropsWithChildren) => {
  const [store, reducerDispatch] = useReducer(mainReducer, initialState());
  const dispatch = useCallback(mainDispatch(reducerDispatch, store), []);

  return (
    <AppStoreContext.Provider value={store}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStoreContext.Provider>
  );
};
